{
  "pickups": {
    "health_pack": {
      "amount": 25,
      "glowColor": "#00ff66",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 30
    },
    "shield_booster": {
      "amount": 50,
      "glowColor": "#00ffff",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 30
    },
    "ammo_bullet": {
      "amount": 30,
      "glowColor": "#ffcc00",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "ammo_plasma": {
      "amount": 20,
      "glowColor": "#cc44ff",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "ammo_rocket": {
      "amount": 5,
      "glowColor": "#ff3300",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "keycard_red": {
      "amount": 1,
      "glowColor": "#ff0044",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "keycard_blue": {
      "amount": 1,
      "glowColor": "#0088ff",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "keycard_gold": {
      "amount": 1,
      "glowColor": "#ffcc00",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "health-tank": {
      "amount": 50,
      "glowColor": "#00ffff",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 30
    },
    "energy-tank": {
      "amount": 50,
      "glowColor": "#ffcc00",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 30
    },
    "reserve-tank": {
      "amount": 1,
      "glowColor": "#00ff66",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 30
    },
    "spread-ammo": {
      "amount": 25,
      "glowColor": "#ff3300",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "missile-ammo": {
      "amount": 5,
      "glowColor": "#ffaa00",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "gyrex-ammo": {
      "amount": 15,
      "glowColor": "#cc44ff",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "cannon-ammo": {
      "amount": 10,
      "glowColor": "#ff8800",
      "bobSpeed": 2.0,
      "bobHeight": 0.1,
      "spinSpeed": 1.5,
      "respawnTime": 20
    },
    "keycard-red": {
      "amount": 1,
      "glowColor": "#ff0044",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "keycard-blue": {
      "amount": 1,
      "glowColor": "#0088ff",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "keycard-yellow": {
      "amount": 1,
      "glowColor": "#ffcc00",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    },
    "keycard-green": {
      "amount": 1,
      "glowColor": "#00ff66",
      "bobSpeed": 1.5,
      "bobHeight": 0.08,
      "spinSpeed": 1.0,
      "respawnTime": 0
    }
  },
  "destructibles": {
    "crate": {
      "hp": 50,
      "debrisCount": 8,
      "explosionRadius": 2.0,
      "explosiveDamage": 0
    },
    "barrel": {
      "hp": 20,
      "debrisCount": 12,
      "explosionRadius": 5.0,
      "explosiveDamage": 75
    }
  }
}
